<div class="horizontal-select" (click)="$event.stopPropagation()">
	@if (showLabel) {
		<p class="select-label">{{ 'condition_grade' | translate }}</p>
	}
	<div class="condition-grades">
		@for (item of grades(); track item) {
			<div
				class="condition-grade level-{{ item < 0 ? 'iu' : item }}"
				[class.default-cursor]="staticValue"
				[class.selected]="selectedItem() === item"
				(click)="!staticValue && toggleSelection(item)"
				[matTooltip]="getTooltipText(item)"
			>
				{{ item < 0 ? 'IU' : item }}
			</div>
		}
	</div>
</div>
